import React from 'react'

const Tools = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Tools</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className='bx bxl-figma'></i>

                    <div>
                        <h3 className="skills__name">Figma</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                    <i className='bx bxl-github' ></i>

                    <div>
                        <h3 className="skills__name">GitHub</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                <i className='bx bxl-visual-studio'></i>

                    <div>
                        <h3 className="skills__name">VS Code</h3>
                        
                    </div>
                </div>
            </div>
            <div className="skills__group">
                <div className="skills__data">
                <i className='bx bxl-discord-alt' ></i>
                    <div>
                        <h3 className="skills__name">Discord</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                <i className='bx bxl-linkedin-square' ></i>

                    <div>
                        <h3 className="skills__name">LinkedIn</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                <i className='bx bxl-blender'></i>

                    <div>
                        <h3 className="skills__name">Blender</h3>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Tools